// extracted by mini-css-extract-plugin
export default {"backgound":"style_backgound__2souk","layout":"style_layout__4R91e"};